export default {
  email: 'Email',
  physicalAddress: 'Endereço físico',
  webSiteUrl: 'URL do site',
  loadingApplication: 'Aplicativo de carregamento',
  baseUrl: 'Base URL',
  redirectionUrl: 'URL de redirecionamento',
  prefix: 'Prefixo',
  pickAApplicationColor: 'Selecione uma cor para sua aplicação',
  applicationSuccessfullyUpdated: 'Aplicativo foi atualizado com sucesso',
  apiKeyCopied: 'Chave de Api copiada',
  apiKeyCopyError: 'Erro copiando chave de API',
  changingPublicKeyWillAffectApps: 'A alteração da chave pública afetará todos os aplicativos em uso. Você quer continuar?',
  apiKey: 'Chaves de API',
  goToApiDoc: 'Vá ao API Doc',
  publicKey: 'Chave Pública',
  privateKey: 'Chave Privada',
  generate: 'Gerar',
  reNewPublicKey: 'Renovar a chave pública',
  deleteInfoField: 'Excluir campo de informações',
  sureToDeleteInfoField: 'Tem certeza de que deseja excluir esse campo de informações?',
  addInfoOfPeopleOfBrand: 'Informações adicionais sobre as pessoas da sua marca',
  sectionAddInfoPeopleOfBrandRequested: 'Nesta seção você pode adicionar informações adicionais que serão solicitadas de pessoas de sua marca',
  onlyBeSeenByAppAdministrator: 'Só é possível ser visto pelo administrador do aplicativo',
  canBeSeenByPeople: 'Pode ser visto e modificado por pessoas de seu perfil',
  shortTextField: 'Campo de texto curto',
  dropDownList: 'Lista de drop-down',
  addNewInfoField: 'Adicionar novo campo de informações',
  enterExtraDataId: 'Digite o identificador extradados',
  epayCoCredentials: 'Credenciais Epayco',
  emailVerifyCredentials: 'Email Verificação de Credenciais',
  testEnvironment: 'Ambiente de teste',
  update: 'Atualização',
  modifyAddInfoField: 'Modificar o campo de informações adicionais',
  createAddInfoField: 'Criar campo de informações adicionais',
  fieldSuccessfullyDeleted: 'O campo foi excluído com sucesso',
  fieldName: 'Nome de campo',
  access: 'Acesso',
  addOptions: 'Adicionar opções',
  option: 'Opção | Opções',
  fieldSuccessfullyCreated: 'Field foi criado com sucesso',
  fieldSuccessfullyUpdated: 'Field foi atualizado com sucesso',
  application: 'Aplicação | Aplicativos',
  addAdministrator: 'Adicionar administrador',
  administratorsPerPage: 'Administradores por página',
  yes: 'Sim',
  no: 'No',
  loadingAdministrators: 'Administradores de carregamento',
  noAdministratorsRegistered: 'Sem administradores registrados',
  action: 'Ação | Ações',
  publicKeyUpdated: 'A Chave Pública foi atualizada',
  editAdministrator: 'Editar administrador',
  newAdministrator: 'Novo administrador',
  selectAdministratorType: 'Selecione o tipo de administrador',
  wantAdministratorInactive: 'Você quer que o administrador fique inativo?',
  selectAdministratorPermissions: 'Selecione as permissões do administrador',
  addNewAdministrator: 'Adicionar novo administrador',
  administratorSuccessfullyCreated: 'Administrador criado com sucesso',
  administratorSuccessfullyUpdate: 'Administrador atualizado com sucesso',
  wantToDeleteAdministrator: 'Deseja excluir este administrador?',
  deleteAdministrator: 'Excluir administrador',
  administratorSuccessfullyDeleted: 'Administrador excluído com sucesso',
  successfullyColorUpdated: 'Cor atualizada com sucesso',
  creditCard: 'Cartão de crédito',
  inviteFinancier: 'Convidar financista | Convide o financista',
  billing: 'Faturamento',
  addCreditCard: 'Adicionar cartão de crédito',
  loadBalance: 'Equilíbrio de carga',
  usage: 'Uso | Uso | O uso',
  payment: 'Pagamento | o pagamento | pagamentos | Os pagamentos',
  paymentMethods: 'Métodos de Pagamentos',
  completeBusinessDataBeforeAddingCreditCard: 'Complete os detalhes do seu negócio antes de adicionar um cartão de crédito',
  lastDigits: 'Últimos dígitos',
  cardExpirationDate: 'Data de validade',
  changeToPrincipal: 'Mudar para Diretor',
  creditCardSuccessfullyDeleted: 'Cartão de crédito excluído com sucesso',
  errorDeletingCreditCard: 'Ocorreu um erro excluindo seu cartão',
  creditCardPriorityUpdated: 'Prioridade de Cartões de Crédito atualizada',
  dailyUsage: 'Uso Diário',
  report: 'Relatório',
  recordsPerPage: 'Registros por página',
  loadingRecords: 'Carregando registros',
  noMovementsRecords: 'Não há registros de movimentos',
  service: 'Serviço',
  amount: 'Quantidade',
  value: 'Valor',
  successfullyMovementsReportDownloaded: 'O relatório do movimento foi baixado com sucesso',
  detailedConsumption: 'Consumo Detalhado',
  approved: 'Aprovado | Aprovado',
  creditCardRechargeWithOutCharge: 'Recarregar cartão de crédito sem custo',
  methodOf: 'Método de',
  billCollection: 'Cobrança de Contas',
  NoAdditionalInfoOfPayment: 'Sem informações adicionais de pagamento',
  noPaymentsRecords: 'Sem registros de pagamento',
  invoice: 'Factura',
  deposit: 'Depósito',
  makePayment: 'Fazer o pagamento',
  warning: 'Aviso',
  rechargeToAvoidBlockingMainFunctions: 'Você deve recarregar sua conta para evitar bloquear suas principais funções',
  load: 'Carga',
  enterIdCardNumber: 'Digite seu número de identificação',
  idCardNumber: 'Número de identificação',
  createCard: 'Criar cartão',
  youMustCompleteCardInformation: 'Você deve completar os detalhes do seu cartão de crédito',
  cardInformationIncorrect: 'Os detalhes do cartão estão incorretos',
  creditCardSuccessfullyAdded: 'Cartão de crédito adicionado com sucesso',
  checkCardDetails: 'Confira os detalhes do cartão',
  rejectedCard: 'O cartão foi rejeitado.',
  errorAddingCardPleaseTryAgain: 'Cartão de adição de erros. Por favor tente de novo.',
  noDependencies: 'Sem dependências',
  dependsOn: 'Depende',
  journeyId: 'Journey ID',
  loadingJourneys: 'Jornadas de carregamento',
  noJourneysForThisApp: 'Sem jornadas para este aplicativo',
  editJourney: 'Editar jornada',
  addNewJourney: 'Adicionar nova jornada',
  dependencies: 'Dependências',
  selectJourneyColor: 'Selecione a cor da viagem',
  chooseAColor: 'Escolha uma cor',
  wantThisDefaultStateWhenSomeoneSignsUp: 'Você quer que este seja o estado padrão quando alguém se inscreve?',
  wantToShowThisStateOnTheSideMenu: 'Deseja exibir esse status no menu lateral?',
  loadingJourney: 'Jornada de carregamento',
  addJourney: 'Adicionar jornada',
  journeySuccessfullyCreated: 'Jornada criada com sucesso',
  journeySuccessfullyEdited: 'Jornada editada com sucesso',
  yellow: 'Amarelo',
  orange: 'Laranja',
  red: 'Vermelho',
  purple: 'Roxo',
  darkBlue: 'Azul Escuro',
  lightBlue: 'Azul Claro',
  green: 'Verde',
  wantToDeleteJourney: 'Deseja apagar esta Jornada?',
  deleteJourney: 'Excluir jornada',
  journeySuccessfullyDeleted: 'Jornada excluída com sucesso',
  clickToSearchOnTheComputer: '... ou clique aqui para pesquisar arquivos em seu computador',
  lastName: 'Sobrenome',
  logInWith: 'Faça login com',
  signInWith: 'Faça login com',
  logInToYourAccount: 'Faça login em sua conta',
  signIn: 'Entrar',
  selectColor: 'Selecione a cor',
  selectLogo: 'Selecione o logotipo',
  customPhrase: 'Frase personalizada',
  customPhraseOnLogIn: 'Frase personalizada no login',
  customPhraseOnSignIn: 'Frase personalizada no login',
  enterSignInMode: 'Digite o sinal no modo',
  customPhraseOnLogInButton: 'Frase personalizada no botão de login',
  customPhraseOnSignInButton: 'Frase personalizada no botão de sinal',
  hideSocialNetworks: 'esconder Redes Sociais',
  showSignInFirst: 'Mostrar o sinal em primeiro lugar',
  showCustomButton: 'Mostrar botão personalizado',
  buttonText: 'Texto do botão',
  requestData: 'Solicitar dados',
  defaultData: 'Dados padrão',
  identification: 'Identificação',
  department: 'Departamento',
  healthProvider: 'Provedor de saúde',
  bloodType: 'tipo de sangue',
  day: 'dia | Dias',
  month: 'mês | Meses',
  allTheData: 'Todos os dados',
  year: 'ano | Anos',
  range: 'Gama',
  insertTheHtmlTemplateInTheFollowingField: 'Insira o modelo html no campo a seguir',
  templatePreview: 'Visualização de modelo',
  profilePicUpdated: 'Foto de perfil atualizada',
  /* Forms */
  solo: 'Solo',
  normal: 'Normal',
  needToRefreshBeforeCreateForms: 'Você precisa atualizar antes de criar formulários',
  createForm: 'Criar formulário',
  formsPerPage: 'Formulários por página',
  loadingForms: 'Formulários de carregamento',
  noFormsRegistered: 'Não há formulários registrados',
  formName: 'Nome da forma',
  insertFormOnWebSite: 'Insira formulário em seu Site',
  personalization: 'Personalização',
  injectableCode: 'Código injetável',
  customYourFormAndInsertGeneratedCodeOnTheNextTab: 'Personalize seu formulário e em seguida insira o código gerado na seguinte guia',
  style: 'Estilo',
  responseMessageSent: 'Mensagem de resposta enviada',
  sendButton: 'Botão de envio',
  length: 'Comprimento',
  alignment: 'Alinhamento',
  selectFormColor: 'Selecione sua cor de formulário',
  divWithKeybeFormsToInsertForm: 'Para inserir um formulário em seu site, você deve criar um elemento DIV com a identificação \'keybe-forms\' no corpo do seu site',
  andThenAddTheNextScriptToTheFooter: 'em seguida adicione o script a seguir no Rodapé do seu site',
  left: 'Deixou',
  right: 'Certo',
  center: 'Centro',
  small: 'Pequeno',
  large: 'Grande',
  none: 'Nenhum',
  outlined: 'Descrito',
  filled: 'Preenchido',
  editForm: 'Formulário de edição',
  registerForm: 'Formulário de Registro',
  obligateLogIn: 'Login obrigatório?',
  assignRoleWhenFormIsCompleted: 'Atribuir função quando o formulário for preenchido?',
  setUpNotificationsEmailForm: 'Configure um e-mail onde você receberá notificações de um envio de formulário',
  emailSubject: 'Assunto de e-mail',
  sendEmailOnSubmit: 'Envie e-mail ao receber envio',
  sendSmsOnSubmit: 'Enviar SMS ao receber enviar',
  fields: 'Campos',
  addField: 'Adicionar campo',
  needToSelectRegisterEmailOrPhone: 'Você deve selecionar o e-mail de registro ou telefone',
  formSuccessfullyEdited: 'O formulário foi editado com sucesso',
  fieldLength: 'Comprimento do campo',
  required: 'Necessário',
  minFiles: 'Número mínimo de arquivos',
  linkOfTermsAndConditions: 'Link para termos e condições',
  dataHandlingLink: 'Link de manipulação de dados',
  verificationFields: 'Campos de verificação',
  filesUpLoad: 'Upload de arquivos',
  dataManagement: 'Gestão de dados',
  hide: 'Esconder',
  multipleOption: 'Múltipla escolha',
  NoRestrictions: 'Sem restrições',
  fullRow: 'Linha completa',
  halfRow: 'Meia fila',
  newForm: 'Nova forma',
  addNewForm: 'Adicionar novo formulário',
  formSuccessfullyCreated: 'Formulário criado corretamente',
  files: 'Arquivos',
  fileType: 'Tipo de arquivo',
  responses: 'Respostas',
  responsesPerPage: 'Respostas por página',
  loadingResponses: 'Respostas de carregamento',
  noResponsesYet: 'você não recebeu uma resposta ainda',
  next: 'Próximo',
  largeTextField: 'Grande campo de texto',
  registry: 'Registro',
  creatingANewApplicationIsVerySimpleJustFillInTheInformationWeRequestToGoToTheNextStep: 'Criar um novo aplicativo é muito simples basta preencher as informações que solicitamos para ir para o próximo passo (Configurar redes sociais)',
  applicationName: 'Nome do aplicativo',
  addNewApplication: 'Criar novo aplicativo',
  applicationSuccessfullyCreated: 'O aplicativo foi criado com sucesso',
  saveNewBusiness: 'Salvar novos negócios',
  thePageYouAreLookingForDoesNotExist: 'A página que você está procurando não existe',
  address: 'Endereço',
  city: 'Cidade',
  country: 'País',
  cellPhone: 'Número de celular',
  documentType: 'Tipo de ID',
  darkTheme: 'Tema escuro',
  lightTheme: 'Tema claro',
  sidebar: 'Barra Lateral',
  toolbar: 'Barra de ferramentas',
  money: 'Dinheiro',
  showFieldInPeopleFilters: 'Mostrar campo nos filtros de pessoas',
  timeZoneInformation: `
  Atribuir o seu fuso horário é essencial para que as
  tarefas atribuídas a você e as datas de criação e
  atualização de dados sejam exibidas corretamente.
  `
}
